<template>
  <component :is="loadedComponent" v-if="loadedComponent" />
</template>

<script>
export default {
  data() {
    return {
      loadedComponent: null,
    };
  },
  async created() {
    const host = window.location.hostname;

    const isAto =
        host === "akademi.atonet.org.tr";

    if (isAto) {
      const module = await import("./AtoLogin.vue");
      this.loadedComponent = module.default;
    } else {
      const module = await import("./Login.vue");
      this.loadedComponent = module.default;
    }
  },
};
</script>
